import styles from "./FleekCoinDetailsCard.module.css"
import checkBoxIcon from "../../asset/icons/checkboxTick.png";
import FleekCoin from "../../asset/icons/fleek-coin-logo.png"
import { FLEEK_PLAYSTORE_LINK } from "../../constants";
import React from "react";

export const FleekCoinDetailsCard = ({fleekCoins, useFleekCoin, toggleUseFleekCoin, cartData = {}})=>{    
    if(!cartData.coin_value_reserved) {
        cartData.coin_value_reserved = 0;
    }

    const getCurrencySymbol = (currency_type) => {
        return currency_type === 'usd' ? '$' : '₹';
    }

    // Get currency type from cart data or localStorage
    const currencyType = cartData?.subscription_plan?.currency_type || localStorage.getItem('current_currency_type') || 'inr';
    const currencySymbol = getCurrencySymbol(currencyType);

    // Use coin_value for USD and coin_value_in_inr for INR
    const availableCoinValue = currencyType === 'usd' ? fleekCoins?.coin_value : fleekCoins?.coin_value_in_inr;

    return(
        <div className={styles.card}>
            <div className={styles.upperPortion}>
                <label className={styles.custom_checkbox}>
                    <input
                        onChange={toggleUseFleekCoin}
                        type="checkbox"
                        checked={useFleekCoin}
                    />
                    {
                        useFleekCoin 
                        ?
                        <span className={styles.checkmark}>
                            <img src={checkBoxIcon} alt="checkBoxIcon" className={styles.checkBoxIcon} />
                        </span>
                        :
                        <span className={styles.checkmark}></span>
                    }
                </label>
                <div className={styles.coinDetail}>
                    <div className={styles.coinDetail1}>
                        <p>Pay <span className={styles.bold}>{currencySymbol} {Math.floor(cartData.coin_value_reserved)}</span> using Fleekcoin</p>
                        <img src={FleekCoin} alt="FleekCoin" className={styles.FleekCoin} />
                    </div>
                    <div className={styles.coinDetail2}>
                        <p>Available balance :<span className={styles.coinColor}> {currencySymbol} {Math.floor(availableCoinValue)}</span></p>
                    </div>
                </div>
            </div>
            {!useFleekCoin && <div className={styles.applyFleekSection}>
                Apply FleekCoin to save {currencySymbol} {Math.floor(cartData.coin_value_reserved)}
            </div>}
        </div>
    )
}

export const EarnFleekCoinsCard = () => {
    return (
        <div className={styles.card}>
            <div className={styles.upperPortion}>
                <div className={styles.coinDetail}>
                    <div className={styles.coinDetail1}>
                        <p>Earn Fleekcoins through the Fleek app and save more!</p>
                        <img src={FleekCoin} alt="FleekCoin" className={styles.FleekCoin} />
                    </div>
                    <div className={styles.coinDetail2}>
                        <a href={FLEEK_PLAYSTORE_LINK} target="_blank" rel="noopener noreferrer" className={styles.whiteLink}>
                            Download the app now!
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};